import * as Long from "long";
import { ofType } from "redux-observable";
import { filter, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { networkNoticeCoopInfoHandler } from "../../network/handlers/networkNoticeCoopInfoHandler";
export var epicCoopInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.Received), filter(function (action) {
        return action.playerInfo != undefined &&
            action.playerInfo.playerId != undefined &&
            action.playerInfo.coopId != undefined &&
            !action.playerInfo.coopId.equals(Long.ZERO);
    }), switchMap(function (action) {
        var _a = state$.value.playerInfo, playerId = _a.playerId, coopId = _a.coopId;
        return deps.netSend({
            id: CommandCode.CoopInfo,
            props: {
                coopId: coopId,
                playerId: playerId,
            },
        });
    }), retry(), switchMap(function (res) {
        return networkNoticeCoopInfoHandler(action$, state$, deps)(res);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopInfo.ts
// module id = 1804
// module chunks = 3